/**
 * Composable for managing the accessible PDF preference.
 * When the feature is enabled, accessible PDFs are always used.
 * Shared across PDFViewer, AgendaViewer, and meeting pages.
 */
export const useAccessiblePdfPreference = () => {
    const config = useRuntimeConfig();

    // Check if accessible PDF feature is enabled. Wrapped in a computed
    // so callers can read `.value` consistently and templates auto-unwrap.
    const featureEnabled = computed(() => !!config.public.pdfAccessibleEnabled);

    // Accessible mode is always on when the feature is enabled
    const accessibleEnabled = computed(() => featureEnabled.value);

    return {
        accessibleEnabled,
        featureEnabled
    };
};
